export const COUNTRY_PANAMA = 2;

// Tipo de impuesto ITBMS (SWIFT_CODIGO_IMPUESTO), por defecto en los productos de Panamá
export const PANAMA_ITBMS_TAX_CODE = '51';

export const isPanamaMerchant = (merchant?: { country_id?: number | string } | null) =>
    Number(merchant?.country_id) === COUNTRY_PANAMA;

/**
 * Nombre del catálogo de bienes y servicios del país (FC_CATALOGO_BIENES_SERVICIOS por ID_PAIS).
 * El producto guarda un código de ese catálogo y el impuesto sale del código, igual en los dos países.
 */
export const catalogName = (merchant?: { country_id?: number | string } | null) =>
    isPanamaMerchant(merchant) ? 'Codificación Panameña de Bienes y Servicios' : 'Código de hacienda';
